/** One shape for all three follow-up min-buy lines, so the formatter can pick any of them. */
type MinBuyFollowupParams = { product: string; amount: string; existing: string; min: string };

export const T = {
  en_GB: {
    minBuyFollowupBuy: (p: MinBuyFollowupParams) =>
      `${p.product}: purchase of ${p.amount} is below the minimum buy of ${p.min}.`,
    minBuyFollowupTopup: (p: MinBuyFollowupParams) =>
      `${p.product}: top-up of ${p.amount} on the existing ${p.existing} is below the minimum buy of ${p.min}.`,
    minBuyFollowupSwitch: (p: MinBuyFollowupParams) =>
      `${p.product}: a switch of about ${p.amount} into it is below the minimum buy of ${p.min}.`,
  },
  nb_NO: {
    minBuyFollowupBuy: (p: MinBuyFollowupParams) =>
      `${p.product}: kjøp på ${p.amount} er under minstekjøpet på ${p.min}.`,
    minBuyFollowupTopup: (p: MinBuyFollowupParams) =>
      `${p.product}: påfylling på ${p.amount} til eksisterende ${p.existing} er under minstekjøpet på ${p.min}.`,
    minBuyFollowupSwitch: (p: MinBuyFollowupParams) =>
      `${p.product}: et bytte på ca. ${p.amount} inn i fondet er under minstekjøpet på ${p.min}.`,
  },
} as const;
